var sidebarStatus = $.getCookie('sidebar') == 'true';
$('body').setDataAttribute('sidebar', sidebarStatus);
$('.btn[data-event="sidebar-toggle"]').on('click', function () {
    setSidebarStatus(!sidebarStatus);
});

var setSidebarStatus = function (status) {
    sidebarStatus = status;
    $.setCookie('sidebar', sidebarStatus);
    $('body').setDataAttribute('sidebar', sidebarStatus);
}

$(window).on('resize', function () {
    setSidebarStatus($(window).width() >= 992);
}).trigger('resize');
